import { translate, translateApiError } from "@/lib/translation";
import { API_BASE_URL, authorizedFetch } from "./base";
import { ContactFormPayload } from "./types";

export const sendContactMessage = async (
  data: ContactFormPayload,
): Promise<void> => {
  // API_BASE_URL is validated at import time to ensure HTTPS in production
  const url = `${API_BASE_URL}/contact/`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    let errorMessage = translate("contact:toast.sendContactFailed");

    try {
      const errorBody = await response.json();
      const translated = translateApiError(errorBody);
      if (translated !== null) {
        errorMessage = translated;
      } else if (typeof errorBody?.detail === "string") {
        errorMessage = errorBody.detail;
      } else if (typeof errorBody?.message === "string") {
        errorMessage = errorBody.message;
      }
    } catch {
      /* ignore JSON parsing errors */
    }

    throw new Error(errorMessage);
  }
};

export const sendAuthContactMessage = async (
  data: ContactFormPayload,
): Promise<void> => {
  await authorizedFetch<void>("/contact/me", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name: data.name,
      reply_to_email: data.reply_to_email,
      subject: data.subject,
      message_content: data.message_content,
      attachments: data.attachments ?? null,
    }),
  });
};
